import { render } from "./GetPayments.vue?vue&type=template&id=0830495c"
import script from "./GetPayments.vue?vue&type=script&lang=js"
export * from "./GetPayments.vue?vue&type=script&lang=js"

import "./GetPayments.vue?vue&type=style&index=0&id=0830495c&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__